<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3" v-if="product">
        <HMCustomContent
          :html="product.product_description"
          :json="product.product_description_new"
        />
      </div>
    </div>
    <div
      v-if="isPrivateCoaching && product.use_internal_scheduling"
      class="mt-4"
    >
      <h4>{{ $t('PRODUCTS.LABELS.MY_AVAILABILITY') }}</h4>
      <span>
        {{ $t('PRODUCTS.TEXT.AVAILABILITY_DESCRIPTION') }}
      </span>
      <PrivateSchedulingCalendar
        class="mt-4"
        :studioURL="$studioURL"
        :productId="product.id"
        :duration="product.time_slot_duration"
        :readOnly="true"
        @booked="() => {}"
      />
    </div>
    <div v-if="false">
      <div class="py-5" v-for="item in salesPageItems" :key="item.key">
        <component
          :is="getComponentName(item.key)"
          :data="item.data"
        ></component>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useProductStore } from '@/stores';
import StudioSimpleContentPreview from '@/components/products/StudioSimpleContentPreview.vue';
import StudioSignUpBannerPreview from '@/components/products/StudioSignUpBannerPreview.vue';
import StudioTestimonialPreview from '@/components/products/StudioTestimonialPreview.vue';
import StudioInstructorsPreview from '@/components/products/StudioInstructorsPreview.vue';
import StudioFaqPreview from '@/components/products/StudioFaqPreview.vue';
import StudioLessonsPreview from '@/components/products/StudioLessonsPreview.vue';
import StudioEventsPreview from '@//components/products/StudioEventsPreview.vue';
import HMCustomContent from '@/components/common/HMCustomContent.vue';
import PrivateSchedulingCalendar from '@/components/products/PrivateSchedulingCalendar.vue';

export default {
  name: 'StudioProductAbout',
  components: {
    HMCustomContent,
    PrivateSchedulingCalendar,
    StudioSimpleContentPreview,
    StudioSignUpBannerPreview,
    StudioTestimonialPreview,
    StudioInstructorsPreview,
    StudioFaqPreview,
    StudioLessonsPreview,
    StudioEventsPreview,
  },
  data() {
    return {
      salesPageComponentsMapper: {
        introduction: 'StudioSimpleContentPreview',
        solution: 'StudioSimpleContentPreview',
        sign_up_banner: 'StudioSignUpBannerPreview',
        testimonial: 'StudioTestimonialPreview',
        instructors: 'StudioInstructorsPreview',
        results: 'StudioSimpleContentPreview',
        bonus: 'StudioSimpleContentPreview',
        faq: 'StudioFaqPreview',
        // included_content: StudioIncludedContentPreview,
        included_events: 'StudioEventsPreview',
        included_lessons: 'StudioLessonsPreview',
      },
    };
  },
  computed: {
    ...mapState(useProductStore, {
      product: 'product',
      salesPageItems: 'salesPageItems',
      canViewProductContent: 'canViewProductContent',
    }),
    isPrivateCoaching() {
      return this.product?.product_type === 'private_coaching';
    },
  },
  methods: {
    getComponentName(key: string) {
      return this.salesPageComponentsMapper[key];
    },
  },
};
</script>